<template lang="pug">
div
  q-card-section.q-gutter-md
    .text-h6.row.justify-between
      .col-auto
        q-icon(name="brush").q-px-md
        span Restaurátorské zásahy
      .col-auto
        q-btn(color="secondary" outline @click="createNewRestoration" icon="add") Přidat
    q-separator
    div(v-for="work in item.works")
      work-card(:workId="work.metadata.id")
      q-separator
</template>

<script>
import { Component } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import { NewRestorationMixin } from '../editor/new-restoration-mixin'
import WorkCard from 'components/restorations/work/WorkCard.vue'

export default @Component({
  props: {
    collectionCode: String,
    itemId: [String, Number]
  },
  components: {
    'work-card': WorkCard
  }
})
class WorksPage extends mixins(NewRestorationMixin) {
  get item () {
    let i = this.oarepo$.collectionItemModule.item.metadata
    if (!i) {
      this.oarepo$.collectionItemModule.reload()
      i = this.oarepo$.collectionItemModule.item.metadata
    }
    return i
  }
}
</script>

<style scoped lang="stylus">

</style>
